var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var CircleDisable = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 19 19" }),
        React.createElement("path", { d: "M9.5002,-0.0003 C14.7382,-0.0003 19.0002,4.2617 19.0002,9.4997 C19.0002,14.7387 14.7382,18.9997 9.5002,18.9997 C4.2612,18.9997 0.0002,14.7387 0.0002,9.4997 C0.0002,4.2617 4.2612,-0.0003 9.5002,-0.0003 Z M3.1562,3.8627 C1.8192,5.3647 1.0002,7.3357 1.0002,9.4997 C1.0002,14.1867 4.8132,17.9997 9.5002,17.9997 C11.6642,17.9997 13.6352,17.1807 15.1372,15.8437 L15.1372,15.8437 Z M9.5002,0.9997 C7.3362,0.9997 5.3652,1.8197 3.8632,3.1557 L3.8632,3.1557 L15.8442,15.1367 C17.1802,13.6347 18.0002,11.6637 18.0002,9.4997 C18.0002,4.8127 14.1872,0.9997 9.5002,0.9997 Z" })));
};
export default CircleDisable;
